/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// TODO Část Vue konfigurace probíhá také v Logger.
// - Přidat metodu Logger#addVue a volat ji odsud.
/**
 * Továrna na [instance Vue objektů](https://vuejs.org/v2/guide/instance.html).
 * Stará se o [globální konfiguraci](https://vuejs.org/v2/api/).
 */
class VueFactory {
  /**
   * @param {VeeValidate} VeeValidate
   * @param {VueConstructor} Vue
   */
  constructor(VeeValidate, Vue) {
    Vue.config.productionTip = false;
    Vue.use(VeeValidate, {
      enableAutoClasses: true,
      // Zpracování reakce na události je nedokonalé.
      // Validace se provádí ještě před odesláním formuláře a mate uživatele.
      // Navíc nelze události měnit např. v závislosti na odeslání formuláře.
      // Reakce jsou deaktivovány nastavením "none".
      // Události je třeba sledovat ručně a reagovat na ně dle potřeby.
      events: 'none',
      classNames: {
        valid: 'valid',
        invalid: 'invalid'
      },
      locale: 'en'
    });
    this.Vue = Vue;
  }

  /**
   * Vytvoří novou Vue instanci.
   * @param {Object} [options] Vue Options.
   * @returns {Vue}
   */
  create(options) {
    return new this.Vue(options);
  }
}

export default VueFactory;
